import React from 'react';
import { MobileBottomDrawer } from 'ui/MobileBottomDrawer/MobileBottomDrawer';
import { ImagesCarousel } from 'ui/ImagesCarousel';

interface IPictureGalleryDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  photos: { displayName: string; url: string }[];
}

export const PictureGalleryDrawer = (props: IPictureGalleryDrawerProps) => {
  return (
    <MobileBottomDrawer isOpen={props.isOpen} onClose={props.onClose} title={props.title}>
      <ImagesCarousel
        images={props.photos}
        showStatus={true}
        showArrows={true}
        showThumbnails={true}
        carouselImageClassName="h-[300px]"
        thumbnailsCarouselClassName="h-[60px]"
      />
    </MobileBottomDrawer>
  );
};
